


































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import routes from '@/routes/routes';
import Mixin from '@/mixins/base';

interface MenuItem {
  Icon: string;
  RouteName: string;
  Title: string;
  TitleKey: string;
}

@Component({
  mixins: [Mixin]
})
export default class DrawerList extends Mixins(Mixin) {
  @Prop({ default: true })
  private readonly disableTooltip!: boolean;

  private activeRoute = '';

  private setActiveRoute(value: string): void {
    this.activeRoute = value;
  }

  @Watch('activeRoute', { immediate: true, deep: false })
  private clearTreeActiveItems(): void {
    this.$root.$emit('treeview-clear-active');
  }

  private get menuItems(): MenuItem[][] {
    return routes.map(routeGroup => routeGroup.map(route => ({
      ...route,
      Title: String(this.$i18n.t(route.TitleKey))
    })));
  }
}
